<template>  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-heart icon--full-color"
  >
    <path
      d="M23.2913 6.61183C22.7805 6.10083 22.1741 5.69547 21.5066 5.41891C20.8392 5.14235 20.1238 5 19.4013 5C18.6788 5 17.9634 5.14235 17.2959 5.41891C16.6285 5.69547 16.022 6.10083 15.5113 6.61183L14.4513 7.67183L13.3913 6.61183C12.3596 5.58013 10.9603 5.00053 9.50129 5.00053C8.04226 5.00053 6.64298 5.58013 5.61129 6.61183C4.5796 7.64352 4 9.04279 4 10.5018C4 11.9609 4.5796 13.3601 5.61129 14.3918L14.4513 23.2318L23.2913 14.3918C23.8023 13.8811 24.2076 13.2746 24.4842 12.6072C24.7608 11.9397 24.9031 11.2243 24.9031 10.5018C24.9031 9.77934 24.7608 9.06393 24.4842 8.39647C24.2076 7.72901 23.8023 7.12258 23.2913 6.61183Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></template>